import { TitleBar } from "../components/TitleBar";
import '../assets/Gear.css';

export const SVSevens = () => {
    return (
        <>
            <TitleBar title={`2025 Silicon Valley 7's Rugby Tournament`}/>
            <div className='title'>Adult</div>
            <ul>
                <li><b>Date:</b> June 28th, 2025</li>
                <li><b>Location:</b> Morgan Hill Sports Complex</li>
                <li><b>Address:</b> 16500 Condit Rd, Morgan Hill, CA 95037</li>
            </ul>
            <p><b>Registration Information</b></p>
            <ul>
                <li><b>Men's Registration (Social or Qualifier):</b> $325 (Two teams for $600)</li>
                <li><b>Women's Registration:</b> $275</li>
                <li>To reserve your slot in the tournament, venmo tournament dues to @svrfc or pay via paypal: <a target="_blank" rel="noreferrer" href="https://www.paypal.com/paypalme/svrfc">https://www.paypal.com/paypalme/svrfc</a></li>
                <li>In the payment notes, please put your team name, which bracket you'd like to play in (social or qualifier), and an email to receive all tournament communications</li>
                <li>Per USA Rugby regulations, all players must be CIPP'd</li>
            </ul>
            <div className='title'>Youth and High School</div>
            <p>Youth and High School Sevens returns to Fair Oaks Park for the third time running. U-8 through U-18. Boys and Girls.</p>
            <ul>
                <li><b>Date:</b> June 14th, 2025</li>
                <li><b>Location:</b> Fair Oaks Park</li>
                <li><b>Address:</b> 540 N Fair Oaks Ave, Sunnyvale, CA 94085</li>
                <li><b><a target="_blank" rel="noreferrer" href="https://events.teamsnap.com/events/43663/register">Register now!</a></b></li>
            </ul>

            <div className="image-wrapper">
                <img src="/images/DoylesLastGame.JPG" alt="RIP Doyle" width="500"/>
            </div>
            <div className="image-wrapper">
                <img src="/images/SV7sWomens.JPG" alt="SV 7s Women" width="500"/>
            </div>
        </>
    );
}